//React
import React from 'react';

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as partnerAction from '../action/partnerAction';
import * as lightboxAction from '../action/lightboxAction';
//Add
import moment from 'moment';
import ReactPaginate from 'react-paginate';
import { LazyLoadImage } from 'react-lazy-load-image-component';
//Material-ui
import Box from '@material-ui/core/Box';
//Icons
//Part
import PartPostGood from './PartPostGood';
//img
import Blank from '../img/blank/blank-1x1.gif';
import Blank2x1 from '../img/blank/blank-2x1.gif';

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      pic: props.pic,
      list: [],
      page: 1,
      isListNext: false,
      datetime: null,
  	}
  }

  componentDidMount() {
    this._partnerPostListGet(1, false);
  }

  _partnerPostListGet(page, scroll) {

    this.props.partnerPostGet(this.state.pic, page, (data) => {
      if (scroll) {
        let elem = document.getElementById('partnerPostList');
        if (elem) {
          let rect = elem.getBoundingClientRect();
          window.scrollTo(0, (window.pageYOffset + rect.top - 50));
        }
      }
      this.setState({
        list: data.list,
        page: page,
        isListNext: data.isListNext,
        datetime: new Date(),
      });

    });
  }


  _partnerPostGoodEdit(postId) {
    if (this.state.pic === this.props.auth.uic) {
      return false;
    }

    this.props.partnerPostGoodEdit(this.state.pic, postId, (data) => {
      let newList = Object.assign([], this.state.list);
			let index = newList.findIndex((value) => value.post_id === postId);
			if (index >= 0) {
				newList[index].good_count = data.goodCount;
        if (data.type === 'add') {
			    newList[index].post_good_sended = 1;
        }
        else {
          newList[index].post_good_sended = 0;
        }
        this.setState({
          list: newList,
        })
			}
    });
  }


  _renderList(value, index) {
    return (
      <Box key={index} className='round12' boxShadow={2} style={{margin:'10px', background:'#FFF'}}>
        <div style={{padding:'2%'}}>
          <div style={{padding:'5px 0px'}}>
            {moment(value.post_date).format("YYYY年MM月DD日")}
          </div>
          <div style={{whiteSpace: 'pre-line'}}>
            {value.post_comment}
          </div>

        </div>
        {
          (Array.isArray(value.photo) === true) &&
          value.photo.map(
            (value, index, arr) => this._renderImg(value.uri, index, arr)
          )
        }
        <div style={{padding:'2%'}}>
          <PartPostGood
            click={ () => this._partnerPostGoodEdit(value.post_id) }
            goodCount={value.good_count}
            goodCountNondisplay={value.post_good_count_nondisplay}
            goodSended={value.post_good_sended}
          />
        </div>

      </Box>
    )
  }

  _renderImg = (uri, index, arr) => {

    let photoList = arr.map(function(value, index) {
      return {src: arr[index].uri + "&W=600&H=600&blur=0&crop=0"};
    });

		if (((arr.length) % 2) === 1 & index === 0) {
			return (
				<div key={index} style={{display:'inline-block', width:'100%'}}>
					<div
            style={{margin:'1px', position:'relative', cursor:'pointer'}}
            onClick={ () => this.props.lightboxOpen(photoList, index) }
          >
            <LazyLoadImage
              src={uri + "&W=600&H=300&blur=0&crop=1"}
              style={{width:"100%", height: "auto", boxSizing:'border-box'}}
              placeholder={<img src={Blank2x1} style={{width:"100%", height: "auto",}} alt='' />}
              alt=''
            />

            <img
              src={Blank}
              style={{
                position: 'absolute',
                left:0,
                top:0,
                width:'100%',
                height:'100%',
              }}
              alt=''
            />
					</div>
				</div>
			);
		}
		else {
			return (
				<div key={index} style={{display:'inline-block', width:'50%'}}>
					<div
            style={{margin:'1px', position:'relative', cursor:'pointer'}}
            onClick={ () => this.props.lightboxOpen(photoList, index) }
          >
            <LazyLoadImage
              src={uri + "&W=300&H=300&blur=0&crop=1"}
              style={{width:"100%", height: "auto", boxSizing:'border-box'}}
              placeholder={<img src={Blank} style={{width:"100%", height: "auto",}} alt='' />}
              alt=''
            />

            <img
              src={Blank}
              style={{
                position: 'absolute',
                left:0,
                top:0,
                width:'100%',
                height:'100%',
              }}
              alt=''
            />
        	</div>
				</div>
			);
		}
	}

	render() {

      if (!this.state.datetime) {
        return (
          <div id='partnerPostList' style={{height:'1000px'}}></div>
        );
      }
      else {
        return (
    			<div id='partnerPostList' style={{padding:'10px'}}>
            <div
              style={{
                display:'flex',
                flexDirection:'row',
                alignItems:'center',
                justifyContent: 'space-between',
                margin: '10px',
              }}
            >
              <div>
                { this.props.postCount }件
              </div>
              <div>
                <span style={{color:'#666'}}>ページ{this.state.page}</span>

              </div>
            </div>

            {
              (Array.isArray(this.state.list) === true) &&
              this.state.list.map((value, index) =>
                this._renderList(value, index)
              )
            }

            {
              (Math.ceil(this.props.postCount / 10) > 1) && (
                <div align='center'>
                  <ReactPaginate
                    breakLabel="…"
                    previousLabel="<"
                    nextLabel=">"
                    onPageChange={ (event) => this._partnerPostListGet((event.selected + 1), true) }
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    pageCount={ Math.ceil(this.props.postCount / 10) }
                    renderOnZeroPageCount={null}
                    containerClassName={'pagingBlock'}
                    pageLinkClassName={'item'}
                    previousLinkClassName={'item'}
                    nextLinkClassName={'item'}
                    activeLinkClassName={'select'}
                    disabledClassName={'itemDisabled'}
                  />
                </div>
              )
            }
    			</div>
    		)
      }


	}
}

const mapStateToProps = (state) => {
	return {
    auth: state.auth,
    partner: state.partner,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...partnerAction,
    ...lightboxAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
